import React from "react";
import { AiFillFire } from "react-icons/ai";
import { Link } from "react-router-dom";
import bg from "../../assets/about.jpg";
const Items = ({
  data: {
    _id,
    price,
    points,
    discount,
    name,
    thumbnail,
    reservation,
    sold,
    pieces,
  },
}) => {
  // const { _id, price, points, discount, name, reservation, sold} = data;

  return (
    <Link to={`/product/${_id}`}>
      <div className="sale_item">
        <div>
          <img
            loading="lazy"
            className="thumbnail"
            src={
              thumbnail
                ? ` https://drive.google.com/thumbnail?id=${thumbnail}`
                : bg
            }
            alt={name}
          />
        </div>
        <div className="name">
          <p> {name.length >= 7 ? ` ${name.substr(0, 7)}...` : name}</p>
          {reservation && <p className="reserve">open for reservation</p>}
        </div>

        <div className="price">
          {discount > 0 && (
            <p className="discounted">
              ₱{price - price * (discount < 100 ? discount : discount / 100)}
            </p>
          )}
          <p className={discount > 0 ? "original strike" : "originalPrice"}>
            ₱{price}
          </p>
        </div>
        {/* <div className="rate">5 star</div> */}
        {points > 0 && <div className="points">{points} pts</div>}
        {discount > 0 && (
          <div className="discount">
            <strike>-{discount < 100 ? discount * 100 : 100}%</strike>
          </div>
        )}

        {sold > pieces && (
          <div className="sold">
            {" "}
            <AiFillFire className="fire-icon" /> {sold} sold
          </div>
        )}
      </div>
    </Link>
  );
};

export default Items;
